/* eslint-disable react-refresh/only-export-components -- context + hook pattern */
import { createContext, useContext } from 'react';
import { notification as antdNotification } from 'antd';

const NotificationContext = createContext({ showNotification: () => {} });

const NotificationProvider = ({ children }) => {
    const [notificationApi, contextHolder] = antdNotification.useNotification();

    const showNotification = (
        type = 'info',
        message = 'Info',
        description = '',
        _concernType = null,
        duration = 6,
        placement = 'bottomRight'
    ) => {
        notificationApi.open({
            type,
            message,
            description,
            duration,
            placement
        });
    };

    return (
        <NotificationContext.Provider value={{ showNotification }}>
            {contextHolder}
            {children}
        </NotificationContext.Provider>
    );
};

export default NotificationProvider;
export const useNotification = () => useContext(NotificationContext);
